// src/pages/PrivateRoute.jsx
// Route guard for admin-only pages.
// Not logged in: redirect to /login to authenticate first.
// Logged in but not an admin: redirect to /404 (the "*" catch-all renders NotFound),
// so the page simply does not exist for them.
// Used as: <Route path="/admin-dash" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function PrivateRoute({ children }) {
  const { isLoggedIn, isAdmin } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/404" replace />;
  }

  return children;
}
